import RejectedInvoicesListContextProvider from './Providers/RejectedInvoicesListContextProvider'
import { RejectedInvoicesList } from './RejectedInvoicesList/RejectedInvoicesList'

export const RejectedInvoices = () => (
  <RejectedInvoicesListContextProvider>
    <RejectedInvoicesList />
  </RejectedInvoicesListContextProvider>
)
